import * as StatusMessage from './Components/StatusMessage.css';
export default {
    StatusMessage
};
